import { render } from "./pickUp.vue?vue&type=template&id=4be886d6&scoped=true"
import script from "./pickUp.vue?vue&type=script&lang=js"
export * from "./pickUp.vue?vue&type=script&lang=js"

import "./pickUp.vue?vue&type=style&index=0&id=4be886d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be886d6"]])

export default __exports__